module.exports = {
  Guide: require('./base'),
  Arc: require('./arc'),
  DataMarker: require('./data-marker'),
  DataRegion: require('./data-region'),
  Html: require('./html'),
  Image: require('./image'),
  Line: require('./line'),
  Region: require('./region'),
  Text: require('./text')
};


//////////////////
// WEBPACK FOOTER
// ./src/guide/index.js
// module id = 256
// module chunks = 0